var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultEntityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7200_4376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1538 4.47451C14.5732 4.89401 14.5371 5.58402 14.0765 5.95778L11.5533 8.0059C11.4702 8.07331 11.4108 8.1654 11.3841 8.26899L10.3393 12.3217C10.2427 12.6964 9.77535 12.824 9.5017 12.5503L7.11591 10.1645L4.70111 12.5793C4.33494 12.9455 3.84056 13.1555 3.32281 13.1649L3.05005 13.1697L3.05488 12.897C3.06429 12.3792 3.27429 11.8848 3.64045 11.5186L6.05525 9.10385L3.66945 6.71805C3.39581 6.44441 3.52333 5.97709 3.89802 5.88044L7.95076 4.83566C8.05437 4.80892 8.14713 4.75026 8.21455 4.66717L10.262 2.14327C10.6357 1.68266 11.3257 1.6466 11.7452 2.06593L14.1538 4.47451Z",
    fill: "#747982"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7200_4376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultEntityIcon);
export default __webpack_public_path__ + "static/media/default-entity-icon.2bb646e271bb6a9a2d4c51713a3c539b.svg";
export { ForwardRef as ReactComponent };